module.exports = __webpack_public_path__ + "media/images/faqs/bg-320-92bb0fc9b50876d3686b0ab2b843949f.png";